import React, { useMemo } from 'react';
import { Link } from '@/shared/ui/link';
import { useI18n } from '@locales/client';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { Image } from '@/shared/ui/image';
import { Box } from '@/shared/ui/box';
import { BodyTextBoldSecondary } from '@/shared/ui/typography';
import {
  Section,
  SectionButton,
  SectionDescription,
  SectionTitle,
  SectionContent,
  ImageElement,
  ImageTemplate,
  ImageBonus,
  DisabledOverlay,
  InfoPseudoButton,
} from './styles';

import type { GameType as Props } from '@/widgets/game-sections/ui/GameSections';
import { useGameAccessCheck } from '@/shared/hooks';
import { useUser } from '@/shared/providers/user-provider/use-user';

const GameComponent = ({
  status,
  wishlistToggleSlot,
  // openNotAlowedModal,
  hasScroll,
  mobileLandscape,
  game,
}: Props) => {
  const accessHelpers = useGameAccessCheck();
  const t = useI18n();
  const { user } = useUser();

  const {
    realGamePath,
    demoGamePath,
    infoPath,
    canOpenGame,
    isDisabled,
    hasBonus,
  } = useMemo(() => {
    return {
      realGamePath: accessHelpers.getGamePath(game, false),
      demoGamePath: accessHelpers.getGamePath(game, true),
      infoPath: accessHelpers.getGameInfoPath(game),
      isDisabled: accessHelpers.isDisabled(game),
      hasBonus: accessHelpers.hasBonus(game),
    };
  }, [game, accessHelpers]);

  // const handleGameClick = (e: React.MouseEvent) => {
  //   if (canOpenGame) {
  //     e.preventDefault();
  //     openNotAlowedModal();
  //     return;
  //   }
  //   e.stopPropagation();
  // };

  return (
    <Section $hasScroll={hasScroll} $status={status} $disabledGame={isDisabled}>
      <DisabledOverlay $disabledGame={isDisabled}>
        <Image
          width={mobileLandscape ? 40 : 70}
          height={mobileLandscape ? 40 : 70}
          src="/images/icons/prohibit.svg"
        />
        <BodyTextBoldSecondary color={!mobileLandscape ? '#AFAFAF' : undefined}>
          {t('unavailable_for_bonus')}
        </BodyTextBoldSecondary>
      </DisabledOverlay>

      <SectionContent>
        <SectionTitle>{game?.title}</SectionTitle>
        <SectionDescription>{game?.providerName}</SectionDescription>
        <Link
          href={user.isAuth ? realGamePath : infoPath}
          // onClick={(e) => handleGameClick(e, false)}
        >
          <SectionButton>
            <Image width={16} height={16} src="/images/icons/play.svg" />
            {t('common.game.card.play')}
          </SectionButton>
        </Link>

        <Box $position="absolute" $bottom={16} $width="100%">
          <Box
            $display="flex"
            $justifyContent="space-between"
            $alignItems="center"
            $padding="0 12px"
          >
            <Link
              href={demoGamePath}
              // onClick={(e) => handleGameClick(e, true)}
            >
              <BodyTextBoldSecondary>
                {t('common.game.card.demo')}
              </BodyTextBoldSecondary>
            </Link>
            <Box $display="flex" $gap={6}>
              <Box>
                <Link href={infoPath}>
                  <InfoPseudoButton />
                </Link>
              </Box>
              <Box>{wishlistToggleSlot}</Box>
            </Box>
          </Box>
        </Box>
      </SectionContent>
      <ImageElement
        $status={status}
        alt={game?.title}
        fill
        sizes="(max-width: 768px) 106px, 150px"
        src={game?.imageUrl}
      />

      {status && <ImageTemplate $status={status}>{status}</ImageTemplate>}
      <ImageBonus $hasBonus={hasBonus} />
    </Section>
  );
};

export const Game = withBreakpointsSlice(
  GameComponent,
  ({ mobileLandscape }) => ({ mobileLandscape })
);
